<template>
  <FormSection
    class="app-cover-upload"
    :title="$t('APP.MEDIA.COVER')"
    :description="description"
  >
    <Card v-loading="loading">
      <DroppableImageSelector
        class="app-cover-upload__uploader"
        clearable
        accept=".png"
        :can-change="false"
        :image="app.cover"
        @change="handleAppCoverChange"
      />

      <ErrorsList :errors="errors" class="app-cover-upload__errors-list" />
    </Card>
  </FormSection>
</template>

<script>
import FormSection from '@@/common/layout/FormSection';
import Card from '@@/common/Card';
import ErrorsList from '@@/common/ErrorsList';
import DroppableImageSelector from '@@/common/file-selectors/DroppableImageSelector';
import { mapActions, mapGetters } from 'vuex';
import { APP_DETAILS, DELETE_APP_COVER } from '@/store/types';

import packageName from '@/mixins/packageName';

export default {
  name: 'AppCoverUpload',
  components: {
    FormSection,
    Card,
    ErrorsList,
    DroppableImageSelector,
  },
  mixins: [packageName],
  data() {
    return {
      loading: false,
      errors: [],
    };
  },
  computed: {
    ...mapGetters({ app: APP_DETAILS }),

    description() {
      const imageLimits = `
        <ul class="image-limits">
          <li>${this.$t('APP.MEDIA.MIN_WIDTH')}: 720px</li>
          <li>${this.$t('APP.MEDIA.MIN_HEIGHT')}: 288px</li>
          <li>${this.$t('APP.MEDIA.ASPECT_RATIO')}: 5:2</li>
          <li>${this.$t('APP.MEDIA.MAX_FILE_SIZE')}: 1MB</li>
          <li>${this.$t('APP.MEDIA.FILE_TYPE')}: png</li>
        </ul>
      `;
      return this.$t('APP.MEDIA.COVER_DESC', { imageLimits });
    },
  },
  methods: {
    ...mapActions({ dispatchDeleteAppCover: DELETE_APP_COVER }),
    handleAppCoverChange(selectedCover) {
      if (!selectedCover) this.deleteAppCover();
    },
    deleteAppCover() {
      this.loading = true;
      this.errors = [];

      return this.dispatchDeleteAppCover(this.packageName)
        .then(({ body: { message } }) => {
          if (message) {
            this.$message.success(message);
          }
        })
        .catch(({ body: { message } = {} }) => {
          const errorMsg = message || this.$t('UNKNOWN_ERROR');
          this.$message.error(errorMsg);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.app-cover-upload {
  &__uploader {
    height: rem-calc(290px);

    @include breakpoint(medium down) {
      height: rem-calc(200px);
    }
  }

  &__errors-list {
    margin-top: $global-margin;
  }

  .image-limits {
    margin-top: $global-margin * 2;
    list-style-position: inside;
    color: #555;
    font-size: 0.9rem;
  }
}
</style>
